import styled from "@emotion/styled";

const Grid = styled.div``;

export default Grid;
